import { configWithAuth } from '../helpers'
import { makeGetRequest, makePostRequest, makePatchRequest, makePutRequest, makeDeleteRequest } from '../helpers/api'

export const userService = {
    getAll: () => makePostRequest('user/get-all', configWithAuth()),
    getUserInfo: () => makeGetRequest('admin/user', configWithAuth()),
    getById: (id) => makeGetRequest('user' + id, configWithAuth()),
    updateUser: (body) => makePutRequest('user', JSON.stringify(body), configWithAuth()),
    getUserStats: (payload) =>
        makeGetRequest(`admin/stats/organization/${payload.organizationId}/user/${payload.userId}`, configWithAuth()),

    resendInvite: (payload) =>
        makePostRequest(
            'admin/organization/' + payload.organizationId + '/user/' + payload.userId + '/resendinvite',
            JSON.stringify(payload),
            configWithAuth()
        ),
    adminUpdateUser: (payload) => makePatchRequest('admin/user/edit/', JSON.stringify(payload), configWithAuth()),
    adminUpdateUserMasterOrganization: (payload) =>
        makePostRequest(
            `admin/user/edit/${payload.userId}/master/organization/${payload.organizationId}`,
            JSON.stringify(payload),
            configWithAuth()
        ),
    updateUserOrganizationRole: (payload) =>
        makePutRequest(
            'admin/user/edit/role/',
            JSON.stringify({
                organizationId: payload.organizationId,
                userId: payload.userId,
                schoolRole: payload.userRole,
            }),
            configWithAuth()
        ),
    createUserMessage: (payload) =>
        makePostRequest(`admin/user/${payload.userId}/create/message`, JSON.stringify(payload), configWithAuth()),

    getUserActivity: (payload) =>
        makePostRequest(
            `admin/stats/organization/${payload.organizationId}/user/${payload.userId}/activity`,
            JSON.stringify({ fromDate: payload.fromDate, toDate: payload.toDate }),
            configWithAuth()
        ),

    // course group (Courses) progression for users
    getUserCourseGroups: (payload) =>
        makeGetRequest(
            `admin/organization/${payload.organizationId}/user/${payload.userId}/course/group`,
            configWithAuth()
        ),
    getUserCourseGroupProgression: (payload) =>
        makeGetRequest(
            `admin/organization/${payload.organizationId}/user/${payload.userId}/course/group/${payload.courseGroupId}/progression`,
            configWithAuth()
        ),

    // lesson progressions (all)
    getUserLessonProgressions: (payload) =>
        makeGetRequest(
            `admin/organization/${payload.organizationId}/user/${payload.userId}/lesson/progressions`,
            configWithAuth()
        ),
    getWritingSubmissions: (payload) =>
        makeGetRequest(
            `admin/organization/${payload.organizationId}/user/${payload.userId}/lesson/${payload.customLessonId}/writing-submissions`,
            configWithAuth()
        ),
    getUserAccessCode: (payload) =>
        makePostRequest(`admin/user/edit/create/access/code`, JSON.stringify(payload), configWithAuth()),
    sendStudentLoginLink: (payload) =>
        makePostRequest('auth/forgot-password-access-code', JSON.stringify(payload), configWithAuth()),

    // Capeesh admin only utilities
    previewWritingScoreRepair: (payload) =>
        makeGetRequest(`admin/utilities/organization/${payload.organizationId}/writing-score-repair`, configWithAuth()),
    getCapeeshAdmins: () => makeGetRequest('admin/access/capeesh-admins', configWithAuth()),
    grantAllOrganizationsReporting: (payload) =>
        makePostRequest('admin/access/all-organizations-reporting', JSON.stringify(payload), configWithAuth()),
    revokeAllOrganizationsReporting: (payload) =>
        makeDeleteRequest(`admin/access/all-organizations-reporting/user/${payload.userId}`, {}, configWithAuth()),

    // Administrators everywhere - every non-Student school role in every organization.
    getAllAdministrators: () => makeGetRequest('admin/access/administrators', configWithAuth()),
    revokeAdministratorAccessForOrganization: (payload) =>
        makeDeleteRequest(
            `admin/access/administrators/organization/${payload.organizationId}/user/${payload.userId}`,
            {},
            configWithAuth()
        ),
    revokeAllAdministratorAccess: (payload) =>
        makeDeleteRequest(`admin/access/administrators/user/${payload.userId}`, {}, configWithAuth()),

    applyWritingScoreRepair: (payload) =>
        makePostRequest(
            `admin/utilities/organization/${payload.organizationId}/writing-score-repair`,
            JSON.stringify({}),
            configWithAuth()
        ),
}
